import React from 'react';
import HelmetPkg from 'react-helmet';
import appData from './app-data';

const Helmet = HelmetPkg.Helmet || HelmetPkg;

const Seo = ({ title, description }) => {
    const { name, logo, aboutUs, landingImage, contactDetails } = appData;
    const siteUrl = 'https://www.graceboundeastafrica.com'; // It's best to use the canonical URL here

    const pageTitle = title ? `${title} | ${name}` : name;
    const metaDescription = description || aboutUs.metaDescription;

    const pageSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: name,
        url: siteUrl,
        logo: `${siteUrl}${logo}`,
        description: metaDescription,
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: contactDetails.phone,
            contactType: 'Customer Service',
            email: contactDetails.email,
        },
        sameAs: appData.footer.socials.map(social => social.link)
    };

    return (
        <>
            <Helmet>
                {/* Standard SEO */}
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
                <link rel="canonical" href={siteUrl} />

                {/* Open Graph (Facebook, etc.) */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content={siteUrl} />
                <meta property="og:image" content={`${siteUrl}${landingImage.image}`} />
                <meta property="og:image:alt" content={landingImage.alt} />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={metaDescription} />
                <meta name="twitter:image" content={`${siteUrl}${landingImage.image}`} />

                {/* JSON-LD Schema */}
                <script type="application/ld+json">
                    {JSON.stringify(pageSchema)}
                </script>
            </Helmet>
        </>
    );
};

export default Seo;